import { useUser } from 'context/UserContext';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';

const HasClassroom = () => {
  const user = useUser();
  if (!user.classroomCode) {
    toast.warning('Per accedere a questa pagina devi far parte di una classe');
    return <Navigate to="/classe" />;
  }
  return <Outlet />;
};

export default HasClassroom;
